<template>
    <div v-loading="loading" 
        element-loading-text="登录中"
        element-loading-background="#f5f5f9"
        element-loading-spinner="el-icon-loading"
        class="cont">
    </div>
</template>

<script>
    import { Message } from "element-ui";
    // 使用辅助函数
    import {mapMutations} from "vuex";
    import getUserInfo from "../../../assets/js/libs/getUserInfo";
    export default {
        data(){
            return {
                code:"",
                type: "",
                scope:"",
                redirectUri: encodeURI(process.env.VUE_APP_BASE_URL + "/#/login"),
                loading: true,
                nodeEnv: process.env.NODE_ENV,
                redirectLink:""
            }
        },
        methods:{
            goBack(){
                this.$router.go('./index');
            },
            ...mapMutations({
                "login": "user/login"
            }),
            // 拿取code
            getCode(){
                 this.$ajax({
                    url:this.$config.baseApi + "/get_qr",
                    method:'post',
                    data:JSON.stringify({
                        redirectUri:this.redirectUri,
                        scope:this.scope,
                        type:this.type
                    })
                }).then(res=>{
                    if(res.code == 1){
                        // window.location.href = res.data;
                        if(this.type =="wx"){
                            window.location.href = res.data;
                        }else{
                            this.$router.push({path:'/qrCode',query:{link:res.data}})
                        }
                       
                    }
                }).catch(err =>{
                    console.log(err)
                })
            },
            // 通过code获取openid和access_token等；
            getOpenId(){
                this.$ajax({
                    url:this.$config.baseApi + "/get_openid",
                    method:'post',
                    data:JSON.stringify({
                        code:this.code,
                        type:this.type
                    })
                }).then(res=>{
                    if(res.code == 1){
                        // 使用辅助函数给vuex传参
                        this.login({access_token:res.data.access_token,openid:res.data.openid,refresh_token:res.data.refresh_token,isLogin:true});
                        setTimeout(()=>{
                            this.Login()
                        },500)
                    }else{
                        // Message({
                        //     message :"登录失败，请刷新页面",
                        //     type:'success'
                        // })
                        this.getCode();
                    }
                }).catch(err =>{
                    console.log(err)
                })
            },
            // 微信登录
            Login(){
                this.$ajax({
                    url:this.$config.baseApi + "/wx/login",
                    method:'post',
                    data:JSON.stringify({
                        accessToken:this.$store.state.user.access_token,
                        openid:this.$store.state.user.openid,
                        type:this.type
                    })
                }).then(res=>{
                    if(res.code == 1){
                        localStorage['sessionid'] = res.data
                        Message({
                            message :"登录成功",
                            type:'success'
                        })
                        window.sessionStorage.setItem('ShowNoticeDialog',true)
                        getUserInfo()
                        setTimeout(()=>{
                            let lastLink = localStorage.getItem('link')
                            //不重复进入login页面
                            if (lastLink && lastLink.indexOf('login') == -1) {
                                window.location.href = lastLink;
                            } else {
                                this.$router.push('./index');
                            }
                        },500)
                    }else{
                        Message({
                            message :"登陆失败",
                            type:'error'
                        })
                    }
                }).catch(err =>{
                    console.log(err)
                })
            },

            getQueryString(key)
            {
                let data = {};
                let src = window.location.href
                let index = src.indexOf("?");
                if (index === -1) {
                    return null;
                }
                let code = null
                let dataStr = src.substring(src.indexOf("?") + 1);
                let dataArray = dataStr.split("&");
                for (let i = 0; i < dataArray.length; i++) {
                    let param = dataArray[i].split("=");
                    data[param[0]] = param[1];
                    if (param[0] === 'code') {
                        code = param[1]
                    }
                }
                return code
            },
       
            // 临时本地登录
            testLogin(){
                this.login({
                    access_token:"40_PZIWK1QLqWla-9UYR19HHlE4nZLoBNsI8nZ9NSEk23bOmOPyUHc9C6WWscXw98Br8X343BAfCUEZQbd8juA6DBaw-pNymu9_JEt0FjQT09E",
                    openid:"oyZBewIf1HjU19QPKvZby_EPrUC0",
                    refresh_token:"40_8-UdmKk8g_fQ476Q7nrelsXhlMMUARrg_E956dfVmtmJtz9haCK2fCvfXTJ5TLX4wNfl9B3DDLc5OqOY1666rsIjPrPmZTA0WSwlNjQLKcY",
                    isLogin:true
                });
                setTimeout(()=>{
                    this.Login()
                },500)
            }
        },
        created(){
           if(this.$IsPc()){
                this.type = 'wx';
                this.scope = "snsapi_userinfo";
            }else{
                this.type = 'pc';
                this.scope = "snsapi_login";
            };
            
            this.code = this.getQueryString('code')
            console.log(this.redirectUri, 'code=', this.code)
            if (this.nodeEnv == 'development'){
                this.testLogin() // 线下
            }else{
                if(this.code){
                    this.getOpenId();
                }else{
                    this.getCode();
                }
            }
        },
        mounted(){
            document.title=this.$route.meta.title
        },
    }
</script>

<style scoped>
    .cont{
        height: 3rem;
    }
</style>
